import React, { ReactElement, ReactNode, useEffect } from 'react';
import { connect } from 'react-redux';

import { RootState } from 'Redux/store';

import Routes from 'Navigation/Routes';

import Actions from 'Redux/Actions';

import PackageJson from '../../package.json';

import config from '../Config/Config';

interface FullProps {
    startup: () => void;
}

const Full = (props: FullProps): JSX.Element => {
    useEffect(() => {
        const { startup } = props;

        console.log(`Version: ${PackageJson.version} (${config.ENV})`);

        startup();
    }, []);

    return (
        <>
            <Routes />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({

});

const mapDispatchToProps = (dispatch: any) => {
    return {
        startup: () => dispatch(Actions.authStartup()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Full);
